<div class="metadata-div">

  <span class="input-field-label" [matTooltip]="label" matTooltipPosition="above">
    <b>{{label}}</b>
  </span>

<!--  <div *ngIf="visibility === 'MT_O'" class="only-read-metadata-data-div">-->
<!--    {{humanvalue}}-->
<!--  </div>-->

  <app-meta-data-onlyread *ngIf="visibility === 'MT_O'" [value]="humanvalue" [title]="label"></app-meta-data-onlyread>

  <mat-form-field *ngIf="visibility === 'MT_K' || visibility === 'MT_M'">
    <mat-select [formControl]="mftorzsFormControl"
                [required]="visibility==='MT_K'"
                (selectionChange)=" setValue($event.value)"
                placeholder="{{humanvalue ? humanvalue : ('NOT_SELECTED' | translate)}}">
      <mat-option *ngFor="let option of optionList" [value]="option">
        {{option.mfTorzsName}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="mftorzsFormControl.hasError('required')">
      {{'MANDATORY_FIELD' | translate}}
    </mat-error>
  </mat-form-field>

</div>
